import type { Activity, NonConformityReason } from '@/services/WarrantyApiService/types'
import WarrantyApiService from '@/services/WarrantyApiService/WarrantyApiService'
import { useUserStore } from '@/stores/user.store'
import * as Sentry from '@sentry/vue'
import { useQuery } from '@tanstack/vue-query'
import type { Ref } from 'vue'

const { logger } = Sentry

export const useRegisterProductNonCoonformity = (input: {
  manufacturingOrderId: string
  tagCode: string
  activityId: Ref<Activity>
  nonConformityReasons: Ref<NonConformityReason[]>
}) => {
  const userStore = useUserStore()

  return useQuery<any>({
    queryKey: ['fetch-data-non-conformity'],
    queryFn: async () => {
      const nonConformityReasonIds = input.nonConformityReasons.value.map((obj) => obj.id!)

      const data = {
        manufacturingOrderId: input.manufacturingOrderId,
        tagCode: input.tagCode,
        activityId: input.activityId.value.id,
        nonConformityReasonIds: nonConformityReasonIds
      }

      const response = await WarrantyApiService.registerProductNonConformity(data)

      const logData = {
        productionSequenceOperation: userStore.decodedToken?.productionSequenceOperation,
        activity: userStore.decodedToken?.activity,
        accessKey: userStore.decodedToken?.accessKey,
        tagCode: data.tagCode,
        manufacturingOrderId: data.manufacturingOrderId,
        nonConformityReasons: input.nonConformityReasons.value
      }

      if (response.isWrong()) {
        logger.error(`[NÃO CONFORMIDADE] - Erro ao apontar produto`, {
          ...logData,
          error: response.value.message
        })

        throw new Error(response.value.message)
      }

      logger.info(`[NÃO CONFORMIDADE] - Produto apontado`, logData)

      return true
    },
    retry: false,
    enabled: false
  })
}
